import React from 'react';
import { Link } from 'react-router-dom';
import './Policies.css';

const RefundPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Refund & Cancellation Policy</h1>

          <p className="policy-intro">
            This refund and cancellation policy outlines how you can cancel or seek a refund for a product/service 
            that you have purchased through the Platform. Under this policy:
          </p>

          <ol className="policy-list">
            <li>
              <strong>Cancellation Window:</strong> Cancellations will only be considered if the request is made 
              within 3 days of placing the order. However, cancellation requests may not be entertained if the 
              orders have been communicated to such sellers/merchant(s) listed on the Platform and they have 
              initiated the process of shipping them, or the product is out for delivery. In such an event, you 
              may choose to reject the product at the doorstep.
            </li>
            
            <li>
              <strong>Perishable Items:</strong> Pawkit does not accept cancellation requests for perishable items 
              like flowers, eatables, etc. However, the refund/replacement can be made if the user establishes 
              that the quality of the product delivered is not good.
            </li>
            
            <li>
              <strong>Damaged or Defective Items:</strong> In case of receipt of damaged or defective items, please 
              report to our customer service team. The request would be entertained once the seller/merchant listed 
              on the Platform has checked and determined the same at its own end. This should be reported within 
              3 days of receipt of products.
            </li>
            
            <li>
              <strong>Product Not as Described:</strong> In case you feel that the product received is not as shown 
              on the site or as per your expectations, you must bring it to the notice of our customer service within 
              3 days of receiving the product. The customer service team after looking into your complaint will take 
              an appropriate decision.
            </li>
            
            <li>
              <strong>Warranty Issues:</strong> In case of complaints regarding the products that come with a warranty 
              from the manufacturers, please refer the issue to them.
            </li>
            
            <li>
              <strong>Refund Processing:</strong> In case of any refunds approved by Pawkit, it will take 7 days for 
              the refund to be processed to you.
            </li>
          </ol>

          <div className="policy-summary">
            <h2>Quick Summary</h2>
            <table className="policy-table">
              <tbody>
                <tr>
                  <td>Cancellation Period</td>
                  <td>Within 3 days of order</td>
                </tr>
                <tr>
                  <td>Damage Report Period</td>
                  <td>Within 3 days of delivery</td>
                </tr>
                <tr>
                  <td>Refund Processing Time</td>
                  <td>7 days after approval</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2>Contact Us</h2>
          <div className="contact-info">
            <p><strong>Company:</strong> Pawkit</p>
            <p><strong>Address:</strong> Pandepur Road, Varanasi, Uttar Pradesh - 221008</p>
            <p><strong>Email:</strong> <a href="mailto:support@pawkit.in">support@pawkit.in</a></p>
            <p><strong>Phone:</strong> <a href="tel:+916388777710">+91-6388777710</a></p>
            <p><strong>Contact Hours:</strong> Monday - Friday (9:00 AM - 6:00 PM)</p>
          </div>

          <div className="policy-links">
            <h3>Related Policies</h3>
            <ul>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
